import { getGTMEventData } from '@tracking/components/transformer';
import { EVENT_NAMES } from '@tracking/components/constants';

function focusFormatter({ element, formId }) {
  return getGTMEventData(
    EVENT_NAMES.FORM_INPUT_FOCUS,
    'focus',
    { element, formId },
    element,
  );
}

export default focusFormatter;
